<template>
  <div>
    <div 
      v-if="isReportEnabled('transpondersUsedInEvents')" 
      :class="['reportCard', eventActive]" 
      @click="getEvents()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.transponder_usage_report") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('fullRegistrationList')" 
      :class="['reportCard', eventRegistrationActive]" 
      @click="getEventsReg()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.full_registration_list") }}</div>
      <div class="cardDesc"></div>
    </div>
    <ReportCard
      v-if="isReportEnabled('rockyMountainRegistrantReport')" 
      :isActive="eventRockyMountainActive"
      :title="$t('page.report.rocky_mountain_registrant_report')"
      @click="getRockyMountainRegistrant()"
    />

    <div class="v-spacer"></div>
    <v-card v-if="displayTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.transponder_usage_report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-select 
                v-model="raceRegistrationSelected" 
                :items="races_Registration"  
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-registration-races')" 
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete 
                v-model="eventSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                :multiple="true" :outlined="true" dense
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">({{ $t("page.report.filter_selections") }}: {{ eventSelected.length }} )</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="tabulatorData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="tabulatorData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="getReport()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayRegTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.full_registration_list") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete  
                v-model="eventRegistrationSelected" 
                :items="events" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                :multiple="true" 
                :outlined="true" 
                dense
                :no-data-text="$t('common.no_data')"
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">({{ $t("page.report.filter_selections") }}: {{ eventRegistrationSelected.length }} )</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="tabulatorRegData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="tabulatorRegData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="getFullRegistrationReport()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorRegData" :options="tabulatorRegOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <RockyMountainRegistrantReport 
      v-if="displayRockyMountainRegTable" 
    />
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';
import ReportCard from './components/ReportCard.vue';
import RockyMountainRegistrantReport from './components/RockyMountainRegistrantReport.vue';
import ReportsService from '@/services/ReportsService';

export default {
  mixins: [apiCalls],
  components: {
    ReportCard,
    RockyMountainRegistrantReport
  },
  data() {
    return {
      eventSelected: [],
      raceRegistrationSelected: [],
      eventActive: "",
      eventRegistrationActive: "",
      search: "",
      tabulatorData: [],
      displayTable: false,
      displayRegTable: false,
      eventRegistrationSelected: null,
      tabulatorRegData: [],
      eventRockyMountainActive: '',
      displayRockyMountainRegTable: false

    };
  },
  computed: {
    races_Registration: function () {
      let arrayItems = [];

      arrayItems.push({
        id: 0,
        text: this.$t("page.report.label-race"),
      });
      arrayItems.push({
        id: 1,
        text: this.$t("page.report.label-registration"),
      });

      return arrayItems;
    }, 
    tabulatorOptions() { 
      return {
        layout: "fitColumns",
        placeholder: this.$t('common.no_data_set'),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-report-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-className"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("className", "transponder"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-raceNumber"),
            field: "raceNumber",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-eventName"),
            field: "eventName",
            sorter: "string",
            headerFilter: "select",
            headerFilterParams: {values: true},//partial(paramBuilder, "eventName"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-raceName"),
            field: "raceName",
            sorter: "string",
            headerFilter: "select",
            headerFilterParams: {values: true},//partial(paramBuilder, "raceName"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-transponder"),
            field: "transponder",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
        ],
        dataLoaded: function () {
          this.getColumn("eventName").reloadHeaderFilter();
          this.getColumn("raceName").reloadHeaderFilter();
        },
      };
    },
    tabulatorRegOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        columns: [
        {
            title: this.$t("page.report.label-eventName"),
            field: "eventName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 145,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-registration-date"),
            field: "createdDate",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 145,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-participant-name"),
            field: "ParticipanFirstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-participant-lastname"),
            field: "ParticipanLastName",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-number"),
            field: "number",
            sorter: "string",
            formatter: "textarea",
            minWidth: 50,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
          },
          {
            title: this.$t("page.report.label-class-name"),
            field: "name",
            sorter: "alphanum",
            formatter: "textarea",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("name", "registration"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 90
          },
          {
            title: this.$t("page.report.label-email"),
            field: "emailAddress",
            sorter: "alphanum",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 150
          },
          {
            title: this.$t("page.report.label-brand-name"),
            field: "brand",
            sorter: "alphanum",
            formatter: "textarea",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("brand", "registration"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-phone"),
            field: "phone",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-address"),
            field: "address",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-city-name"),
            field: "city",
            sorter: "alphanum",
            formatter: "textarea",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "registration"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-state-name"),
            field: "state",
            sorter: "alphanum",
            formatter: "textarea",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "registration"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-status"),
            field: "status",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("status", "registration"),
            //headerFilterParams: partial(paramBuilder, "eventName"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-buyers-name"),
            field: "RegistrantFirstName",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            //headerFilterParams: partial(paramBuilder, "raceName"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-buyers-lastname"),
            field: "RegistrantLastName",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.label-transponder"),
            field: "tagId",
            sorter: "string",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100
          },
          {
            title: this.$t("page.report.rfidCount"),
            field: "rfidCount",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 50
          },
          {
            title: this.$t("page.report.manualCount"),
            field: "manualCount",
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 50
          },
          {
            title: this.$t("page.report.label-updated-date"),
            field: "updated",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 145,
            formatter: "textarea"
          }
        ]
      };
    },
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig,
      eventItems: (state) => state.reports.eventItems,
      events: (state) => state.reports.events
    })
  },
  methods: {
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, source = "registration") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue)
            ? headerValue
            : (headerValue ? [headerValue] : []);

          if (!selectedValues.length) return true;

          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues
            .map((value) => this.normalizeCaseValue(value))
            .includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const tableData = source === "transponder" ? this.tabulatorData : this.tabulatorRegData;
            const unique = new Set();

            tableData.forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });

            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    refresh(type = "transponder") {
      switch(type) {
        case "transponder":
          this.getReport();
        break;
        case "registration":
          this.getFullRegistrationReport();
        break;
      }
    },
    getEvents() {
      this.eventRegistrationActive = "";
      this.eventRockyMountainActive = "";
      this.displayRegTable = false;
      this.displayRockyMountainRegTable = false;
      if(this.eventActive == "active"){
        this.eventActive = "";
        this.displayTable = false;
      } else {
        this.eventActive = "active";
        this.displayTable = true;
      }
    },
    getEventsReg() {
      this.eventActive = "";
      this.eventRockyMountainActive = "";
      this.displayTable = false;
      this.displayRockyMountainRegTable = false;
      if(this.eventRegistrationActive == "active"){
        this.eventRegistrationActive = "";
        this.displayRegTable = false;
      } else {
        this.eventRegistrationActive = "active";
        this.displayRegTable = true;
      }
    },
    async getReport() {
      this.tabulatorData = [];

      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.clearHeaderFilter();

      if (!this.raceRegistrationSelected?.text) {
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-options-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const isRegistration = this.raceRegistrationSelected.text.toLowerCase() === "registration";
      
      if (isRegistration) {
          tabulatorInstance.hideColumn("raceName");
        } else {
          tabulatorInstance.showColumn("raceName");
        }

      if(!this.eventSelected || this.eventSelected.length === 0) {
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-events-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const dataEvents = this.eventSelected.map(eventId => ({
        eventId
      }));

      const data = {
          param: this.raceRegistrationSelected.text.toLowerCase(),
          events: dataEvents,
        };

        const response = await this.api("post", "/api/v1/promoter/reports/events/transponder", data);
      
      this.tabulatorData = response.map(item => ({
        ...item,
        className: this.$escapeHtml.decode(item.className || ""),
        eventName: this.$escapeHtml.decode(item.eventName),
        raceName: this.$escapeHtml.decode(item.raceName)
      }));
    },
    async getFullRegistrationReport() {
      this.tabulatorRegData = [];

      const tabulatorInstance = this.$refs.tabulator.getInstance();

      tabulatorInstance.clearHeaderFilter();

      if (this.eventRegistrationSelected && Array.isArray(this.eventRegistrationSelected) && this.eventRegistrationSelected.length > 0) {
        const response = await this.api("get", "/api/v1/promoter/reports/events/registration/" + this.eventRegistrationSelected);
        this.tabulatorRegData = response.map((el) => {
          return {
            ...el,
            name: this.$escapeHtml.decode(el.name || ""),
            brand: this.$escapeHtml.decode(el.brand || ""),
            city: this.$escapeHtml.decode(el.city || ""),
            state: this.$escapeHtml.decode(el.state || ""),
            status: this.$escapeHtml.decode(el.status || ""),
            eventName: this.$escapeHtml.decode(el.eventName)
          };
        });
      } else {
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-events-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
      }
    },
    downloadAsPDF() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      //tabulatorInstance.download("pdf", "data.pdf");
      tabulatorInstance.downloadToTab("pdf");
    },
    downloadAsCSV() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      //tabulatorInstance.download("csv", "data.csv", {
      tabulatorInstance.download("csv", "data.csv", {
        delimiter: ",",
      });
    }, 
    isReportEnabled(reportId) {
      return this.reportConfig.events.reports.find(report => report.name === reportId && report.isEnabled) || false;
    },
    getRockyMountainRegistrant() {
      this.eventRockyMountainActive = this.eventRockyMountainActive === "active" ? "" : "active";
      this.displayRockyMountainRegTable = this.eventRockyMountainActive === "active";
      const arrayReportActive = [ 'eventActive', 'eventRegistrationActive' ];
      const arrayReportDisplay = [ 'displayTable', 'displayRegTable' ];
      arrayReportActive.forEach((el) => {
        this[el] = "";
      });
      arrayReportDisplay.forEach((el) => {
        this[el] = false;
      });
    },
    async getEventItems() {
      const response = await ReportsService.getEvents();
      
      if(Array.isArray(response)) {
        this.$store.commit('reports/SET_EVENT_ITEMS', response.map((el) => {
          return {
            id: el.id, text: this.$escapeHtml.decode(el.eventName)
          };
        }));
        this.$store.commit('reports/SET_EVENTS', response.map((el) => {
          return {
            id: el.id, 
            text: `${el.id} :: ${el.eventDate} :: ${this.$escapeHtml.decode(el.eventName)}`
          };
        }));
    }
    }
  },
  created() {},
  mounted() {
    this.getEventItems();
  },
};
</script>

<style scoped lang="scss">
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
